module.exports = __webpack_public_path__ + "img/BLCA_Myofibroblasts.a59d4570.png";